import { render, staticRenderFns } from "./icon-sms.vue?vue&type=template&id=bf6fdc96&"
import script from "./icon-sms.vue?vue&type=script&lang=js&"
export * from "./icon-sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf6fdc96')) {
      api.createRecord('bf6fdc96', component.options)
    } else {
      api.reload('bf6fdc96', component.options)
    }
    module.hot.accept("./icon-sms.vue?vue&type=template&id=bf6fdc96&", function () {
      api.rerender('bf6fdc96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/icon-sms.vue"
export default component.exports